import { report } from "@/services";
import {
  decodeHTML,
  decodeHTMLEntities,
  isSystemGeneratedMessage,
  sanitizeHTML,
} from "@/utils/htmlStr";
import classNames from "classnames";
import { useCallback, useMemo } from "react";
import imageUrl from "../../../../utils/imageUrl";
import HBIcon from "../../../HBIcon";
import HBMessage from "../../../HBMessage";
import ReportModal from "../../../ReportModal";
import styles from "./index.module.less";

export function ContactMessage({
  avatarUrl,
  isMe,
  children,
  messageId,
  urlname,
  userId,
  createdAt,
}) {
  const onReportClick = useCallback(() => {
    ReportModal.open({
      reportType: "私信",
      reportUserId: userId,
      onOk: async ({ reason }) => {
        const { err, msg } = await report({
          type: "dm",
          reason,
          id: messageId,
        });
        if (err) {
          if (err === "already reported") {
            HBMessage.success("你已经举报过了，我们会及时处理哦，谢谢");
          } else {
            console.error("report error:", err);
            HBMessage.error("请求失败：" + msg || err.toString());
          }
        } else {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报"
          );
        }
      },
    });
  }, [messageId, userId]);

  return (
    <div
      className={classNames(styles.contactMessage, { [styles.isMe]: isMe })}
      data-created={new Date(createdAt * 1000).toLocaleString()}
    >
      {isMe ? (
        <img src={avatarUrl} alt="头像" />
      ) : (
        <a href={`/user/${urlname}`} target={"_blank"}>
          <img src={avatarUrl} alt="头像" />
        </a>
      )}
      <div className={styles.message}>{children}</div>
      <HBIcon
        type={"ic_alert"}
        className={styles.reportBtn}
        data-gd-click="button_click"
        data-button-name="举报"
        data-report-type="私信"
        data-report-user-id={userId}
        onClick={onReportClick}
      />
    </div>
  );
}

export default function Wrapper({
  message: { direct_message_id, text, type, from_user, created_at },
}) {
  // 判断是否是系统代发的消息（包含结构化HTML内容）
  // 系统代发：如多人画板邀请等，包含HTML标签和链接
  // 用户输入：即使是HTML标签，也作为纯文本渲染，防止XSS攻击
  const isSystemGenerated = useMemo(() => {
    return isSystemGeneratedMessage(text);
  }, [text]);

  // 根据消息类型选择渲染方式
  const renderContent = useMemo(() => {
    if (isSystemGenerated) {
      // 系统代发：先解码HTML实体，再清理HTML后安全渲染
      // 因为系统消息的HTML可能被转义（&lt; -> <）
      const decodedText = decodeHTMLEntities(text);
      return sanitizeHTML(decodedText);
    } else {
      // 用户输入：纯文本渲染，即使包含HTML标签也会被转义显示
      return decodeHTML(text);
    }
  }, [text, isSystemGenerated]);

  return (
    <ContactMessage
      messageId={direct_message_id}
      isMe={type === "sent"}
      avatarUrl={
        from_user.avatar_url ||
        imageUrl(from_user.avatar, {
          width: 180,
          rect: "sq",
        })
      }
      urlname={from_user.urlname}
      userId={from_user.user_id}
      createdAt={created_at}
    >
      {isSystemGenerated ? (
        // 系统代发：渲染HTML（已清理）
        <div dangerouslySetInnerHTML={{ __html: renderContent }} />
      ) : (
        // 用户输入：纯文本渲染，确保安全
        <div>{renderContent}</div>
      )}
    </ContactMessage>
  );
}
